import { ICourseForSelector, IFlashcardFilters } from '@sdk/contracts';
import { createQueryString } from '@utils';

import { IPaginatedResponse, IPagination } from '../common';
import { RequestService } from '../request';

import {
  ICreateFlashcardCollection,
  IFlashcardCollection,
  IFlashcardCollectionFilters,
  IUpdateFlashcardCollection
} from './flashcard-collection.contract';

export class FlashcardCollectionService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  async createFlashCardCollection(createFlashcardCollection: ICreateFlashcardCollection) {
    return this.poster<IFlashcardCollection, ICreateFlashcardCollection>(
      '/flashcards-collection',
      createFlashcardCollection
    );
  }

  async createFlashcardCollectionWithMovedFlashcard(
    createFlashcardCollection: ICreateFlashcardCollection,
    collectionId: string
  ) {
    return this.poster<IFlashcardCollection, ICreateFlashcardCollection>(
      `/flashcards-collection/${collectionId}`,
      createFlashcardCollection
    );
  }

  async updateFlashCardCollection(updateFlashcardCollection: IUpdateFlashcardCollection) {
    return this.putter<IFlashcardCollection, IUpdateFlashcardCollection>(
      `/flashcards-collection/${updateFlashcardCollection._id}`,
      updateFlashcardCollection
    );
  }

  async getFlashcardsCollections(
    pagination: IPagination,
    sort: Record<string, 'asc' | 'desc'>,
    filters: IFlashcardCollectionFilters
  ) {
    const query = createQueryString({
      page: pagination.page,
      limit: pagination.limit,
      filters,
      sort:
        Object.keys(sort).length > 0
          ? { sort: Object.keys(sort)[0], order: sort[Object.keys(sort)[0]] }
          : undefined
    });
    return this.fetcher<IPaginatedResponse<IFlashcardCollection>>(
      `/flashcards-collection?${query}`
    );
  }

  async getAllFlashcardCollectionsByCourseId(courseId?: string) {
    return this.fetcher<IFlashcardCollection[]>(
      `/flashcards-collection/all-by-course?courseId=${courseId}`
    );
  }

  async getFlashcardsByCollectionId(
    sort: Record<string, 'asc' | 'desc'>,
    filters: IFlashcardFilters,
    collectionId: string
  ) {
    const query = createQueryString({
      filters,
      sort:
        Object.keys(sort).length > 0
          ? { sort: Object.keys(sort)[0], order: sort[Object.keys(sort)[0]] }
          : undefined
    });
    return this.fetcher<IFlashcardCollection>(`/flashcards-collection/${collectionId}?${query}`);
  }

  async removeFlashCardCollection(flashcardCollectionId: string) {
    return this.deleter(`/flashcards-collection/${flashcardCollectionId}`);
  }

  async findAllFlashcardsCoursesForSelectors() {
    return this.fetcher<ICourseForSelector[]>('/flashcards-collection/courses-for-selectors');
  }
}
